import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import _values from "lodash/values";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';
import { Link, Title, Type } from '@nerdwallet/currency';
import Chiclet from '@nerdwallet/react-chiclet';
import { setTrk, TrkElement, TrkTag } from '@nerdwallet/nw-client-lib/trk-helper';
import BestOfBadgeIcon from './best-of-badge-icon';
import { PREHEADER_TRK_LOCATION, PREHEADER_TYPE, SENTIMENT_COLOR, SENTIMENT_TYPE } from './lib/constants';
import styles from './marketplace-product-card.module.less';
import ketoStyles from './keto-product-card/keto-product-card.module.less';

var Preheader = function Preheader(_ref) {
  var _params, _classNames2;

  var className = _ref.className,
      sentiment = _ref.sentiment,
      text = _ref.text,
      title = _ref.title,
      taxonomy = _ref.taxonomy,
      trkPageType = _ref.trkPageType,
      type = _ref.type,
      url = _ref.url,
      isKetoCard = _ref.isKetoCard;

  if (!text) {
    return null;
  }

  var trkLocation = type === PREHEADER_TYPE.BADGE ? PREHEADER_TRK_LOCATION.BEST_OF_BADGE : PREHEADER_TRK_LOCATION.PREHEADER;
  var preheaderHref = url && setTrk({
    url: url,
    taxonomy: taxonomy,
    params: (_params = {}, _defineProperty(_params, TrkTag.location, trkLocation), _defineProperty(_params, TrkTag.copy, text), _defineProperty(_params, TrkTag.element, TrkElement.button), _defineProperty(_params, TrkTag.pageType, trkPageType), _params)
  });
  var styledText = /*#__PURE__*/React.createElement(Title, {
    size: "small",
    className: classNames(classes('color-green-dark'), styles.preheaderText)
  }, text);

  var preheaderContent = function preheaderContent() {
    switch (type) {
      case PREHEADER_TYPE.DECORATED_TEXT:
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Chiclet, {
          text: text,
          color: SENTIMENT_COLOR[sentiment]
        }));

      case PREHEADER_TYPE.PLAIN_TEXT:
        return /*#__PURE__*/React.createElement(Type, {
          size: 1,
          className: classNames(_defineProperty({}, styles.preheaderPlainText, !isKetoCard))
        }, text);

      case PREHEADER_TYPE.BADGE:
      default:
        return styledText;
    }
  };

  var preheaderIcon = function preheaderIcon() {
    switch (type) {
      case PREHEADER_TYPE.BADGE:
        return /*#__PURE__*/React.createElement(BestOfBadgeIcon, {
          title: title,
          className: styles.icon
        });

      default:
        return null;
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames((_classNames2 = {}, _defineProperty(_classNames2, "".concat(styles.preheaderWrapper, " ").concat(styles.preheaderPlainText), !isKetoCard), _defineProperty(_classNames2, ketoStyles.ketopreheaderWrapper, isKetoCard), _classNames2))
  }, preheaderHref ? /*#__PURE__*/React.createElement(Link, {
    href: preheaderHref,
    className: styles.preheaderIconLink
  }, preheaderIcon()) : preheaderIcon(), preheaderHref ? /*#__PURE__*/React.createElement(Link, {
    href: preheaderHref
  }, preheaderContent()) : preheaderContent()));
};

Preheader.propTypes = _objectSpread(_objectSpread({}, BestOfBadgeIcon.propTypes), {}, {
  className: PropTypes.string,
  sentiment: PropTypes.oneOf(_values(SENTIMENT_TYPE)),
  text: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired
});
Preheader.defaultProps = {
  className: ''
};
export default Preheader;